module.exports = __webpack_public_path__ + "static/2007-layer-3-d5d3c23eecab39bbe242a7d2a87c4d58.png";